<template>
<div class="chapter">
<div class="inner_page">
<div class="galley-rw">
<section class="frontmatter-rw Dedication-rw auto-rw page-open-left-rw" epub:type="frontmatter dedication" id="dedication">
<p class="dedication"><a id="page-ix"></a><em>Grammy—</em></p>
<p class="dedication1"><em>thank you</em></p>
<p class="dedication1"><em>for violets,</em></p>
<p class="dedication1"><em>tea parties,</em></p>
<p class="dedication1"><em>and books.</em></p>
<p class="dedication1"><em>Always books.</em></p>
</section>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// dedication.vue?ec69817e